module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"megatrends":"Mega-Trends","macrotrends":"Macro-Trends","industries":"Branchen","relatedMicrotrends":"Verwandte Micro-Trends"},"en":{"megatrends":"Mega-trends","macrotrends":"Macro-trends","industries":"Industries","relatedMicrotrends":"Related micro-trends"}}')
  delete Component.options._Ctor
}
